import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import logo from '../assets/logoFull.png';

const Footer = ({ onNavigate }) => {
  const handleNavClick = (e, page) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page);
    }
  };

  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <a href="#" className="logo" onClick={(e) => handleNavClick(e, 'home')}>
              <img 
                src={logo}
                alt="Shuanghui Power"
                className="logo-image"
              />
            </a>
            <p>
              Shuanghui Power Indonesia adalah produsen switchgear medium voltage
              terkemuka yang menyediakan solusi kelistrikan berkualitas tinggi
              dengan standar internasional.
            </p>
            <div className="footer-social">
              <a href="#" aria-label="Facebook"><FiFacebook /></a>
              <a href="#" aria-label="Twitter"><FiTwitter /></a>
              <a href="#" aria-label="Instagram"><FiInstagram /></a>
              <a href="#" aria-label="LinkedIn"><FiLinkedin /></a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'home')}>Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Products</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#article">Article</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Our Products</h4>
            <ul>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Air Insulated Switchgear</a></li>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Gas Insulated Switchgear</a></li>
              <li><a href="#" onClick={(e) => handleNavClick(e, 'products')}>Metal Clad</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <span className="footer-contact-icon"><FiMapPin /></span>
                <span>PT Shuanghui Power Indonesia Kawasan Industri Terpadu Indonesia China (KITIC, Jl. Anggrek VII Kav. 38, Nagasari, Kec. Serang Baru, Kabupaten Bekasi, Jawa Barat 17330</span>
              </li>
              <li>
                <span className="footer-contact-icon"><FiPhone /></span>
                <span>(021) 3873 3019</span>
              </li>
              <li>
                <span className="footer-contact-icon"><FiMail /></span>
                <span>marketing@shuanghuipower.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Shuanghui Power Indonesia. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
